import { LockKey } from '@phosphor-icons/react';
import IOSToggle from '@/components/IOSToggle';
import { functionTestId } from '@/lib/functionVisibility';

export const CompanyFunctionRow = ({ item, active, disabled, saving, onChange, locked = false, restriction }) => {
  const Icon = item.icon;
  const id = functionTestId(item.to.slice(1));
  return (
    <div className={`flex items-center justify-between gap-3 px-3 sm:px-5 py-3 border-b border-gray-100 transition-colors ${active ? 'bg-white' : 'bg-gray-50'}`}
      data-testid={`function-row-${id}`}>
      <div className="min-w-0 flex items-center gap-3">
        <Icon size={19} className="shrink-0" style={{ color: active ? (item.kleur || '#002FA7') : '#6B7280' }} />
        <div className="min-w-0">
          <span className={`text-sm font-semibold break-words ${active ? 'text-gray-900' : 'text-gray-500'}`}
            data-testid={`function-name-${id}`}>{item.label}</span>
          {locked && <span className="block text-xs text-gray-500 mt-0.5" data-testid="settings-always-available">Altijd bereikbaar</span>}
          {restriction && <span className="block text-xs text-amber-700 mt-0.5" data-testid={`function-restriction-${id}`}>Aanvullende functie-instelling staat uit</span>}
        </div>
      </div>
      <div className="shrink-0 flex items-center justify-end gap-2 sm:gap-4">
        <span className={`text-xs font-semibold min-w-[62px] text-right ${active ? 'text-green-700' : 'text-gray-500'}`}
          aria-live="polite" data-testid={`function-status-${id}`}>
          {saving ? 'Opslaan…' : locked ? <span className="inline-flex items-center gap-1"><LockKey size={12} /> Actief</span> : active ? 'Actief' : 'Deactief'}
        </span>
        <div className="min-h-11 flex items-center" title={locked ? 'Instellingen kan niet gedeactiveerd worden' : item.label}>
          <IOSToggle checked={active} disabled={disabled || locked} size="md" showLabel={false}
            onChange={onChange} ariaLabel={`${item.label} actief`} testid={`function-toggle-${id}`} />
        </div>
      </div>
    </div>
  );
};